let React = require("react");

class Dropdown extends React.Component {

    constructor() {
        super();

        this.toggleShow = this.toggleShow.bind(this);
    }

    toggleShow(){
        this.divShow.classList.toggle("show");
    }

    hideBrothers(){
        let items = document.querySelectorAll(".dropdown__container.show, .dropdown__container .show");
        for (let item of items) {item.classList.remove("show")}
    }

    render() {
        let {name = "", options = [{}], generalTooltip = false} = this.props;
        
        return  <div className="dropdown" onBlur={this.hideBrothers}>
                    <button className="dropdown__text button" onClick={this.toggleShow}>{name}</button>
                    <div className="dropdown__container list" ref={div => this.divShow = div}>
                        {options.map(({name, onClick, selected, tootip, badge = null, className = ""}, index) => 
                            <div key={`${index}-${name}`} 
                                className={`list-item ${selected ? "selected": ""} ${className}`} 
                                onMouseDown={onClick}>

                                <span>{name}</span>
                                {badge}
                                {tootip ? <span className="tooltip">{tootip}</span>: null}
                            </div>)
                        }
                        </div>
                    {generalTooltip ? <span className="tooltip generalTooltip">{generalTooltip}</span>: null}
                    </div>
    }

}

module.exports = Dropdown;
